import {
  Component,
  AfterViewInit,
  OnInit,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AddPermisiuniActiuniComponent } from './add-permisiuni-actiuni/add-permisiuni-actiuni.component';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { EditPermisiuniActiuniComponent } from './edit-permisiuni-actiuni/edit-permisiuni-actiuni.component';
import { PermisiuniActiuniService } from './permisiuni-actiuni.service';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { PermisiuniActiuni } from './permisiuni-actiuni.interface';

@Component({
  selector: 'app-permisiuni-actiuni',
  templateUrl: './permisiuni-actiuni.component.html',
  styleUrls: ['./permisiuni-actiuni.component.scss'],
})
export class PermisiuniActiuniComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  isLoading = false;
  selectedPermisiuniActiune: string = '';

  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();

  dtLink =
    environment.interop.basePath +
    environment.interop.urbanism.nomenclatoare.permissionActions
      .getPermissionActionsDT;

  dataTablesParameters: any = {
    data: {
      key: 'parameter',
    },
  };

  constructor(
    private http: HttpClient,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private permisiuniActiuniService: PermisiuniActiuniService
  ) {}

  ngOnInit(): void {
    this.renderDT();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next('');
  }

  renderDT() {
    this.isLoading = true;
    this.dtOptions = {
      serverSide: true,
      ajax: (dataTablesParameters: any, callback: any) => {
        dataTablesParameters.param1 = 'value1';
        dataTablesParameters.param2 = 'value2';
        dataTablesParameters.param3 = 'value3';

        this.http
          .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
          .subscribe((res: any) => {
            this.isLoading = false;
            callback({
              recordsTotal: res.data.recordsTotal,
              recordsFiltered: res.data.recordsFiltered,
              data: res.data.data,
            });
          });
      },
      language: environment.config.romanianLanguageDataTable,
      columns: [
        {
          title: 'ID',
          data: 'id',
        },
        {
          title: 'Nume',
          data: 'name',
        },
        {
          title: 'Permisiune',
          data: 'id_permission',
        },
        {
          title: 'Acțiuni',
          orderable: false,
          render: () => {
            return `
              <button class="action-btn edit">
                <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
              </button>
              <button class="action-btn delete">
                <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/>
              </button>
            `;
          },
        },
      ],
      rowCallback: (row: Node, data: any[] | any) => {
        const lastTd = (row as HTMLElement).querySelector('td:last-child');
        const editIcon = lastTd?.querySelector('.edit');
        const deleteIcon = lastTd?.querySelector('.delete');

        if (editIcon) {
          editIcon.addEventListener('click', () => {
            this.openEditDialog(data);
          });
        }

        if (deleteIcon) {
          deleteIcon.addEventListener('click', () => {
            const { id } = data;
            this.deletePermisiuniActiune(id);
          });
        }

        return row;
      },
    };
  }

  rerenderDT(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next('');
    });
  }

  deletePermisiuniActiune(permisiuniActiuneId: number) {
    Swal.fire({
      title: 'Sunteți sigur?',
      text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Confirm!',
      cancelButtonText: 'Anulare',
      showLoaderOnConfirm: true,
    }).then((res) => {
      if (res.isConfirmed) {
        this.permisiuniActiuniService
          .deletePermisiuniActiune(permisiuniActiuneId)
          .subscribe(() => {
            this.rerenderDT();
            Swal.fire({
              title: 'Șters!',
              text: 'Acțiune ștearsă cu succes.',
              icon: 'success',
              confirmButtonText: 'OK',
            });
          });
      }
    });
  }

  openAddDialog() {
    const dialogRef = this.dialog.open(AddPermisiuniActiuniComponent, {
      ...this.dialogService.getDialogConfig(),
    });

    dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
      if (success) {
        this.rerenderDT();
      }
    });
  }

  openEditDialog(data: PermisiuniActiuni) {
    const dialogRef = this.dialog.open(EditPermisiuniActiuniComponent, {
      ...this.dialogService.getDialogConfig(),
      data,
    });

    dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
      if (success) {
        this.rerenderDT();
      }
    });
  }
}
